import React, { useState } from 'react';
import classNames from 'classnames';

export interface AvatarProps {
  size?: 'xs' | 's' | 'm' | 'l' | 'xl';
  className?: string;
  text?: string;
  image?: string;
}

const sizes = {
  xs: {
    classNames: 'w-6 h-6 text-ds-caption-s font-ds-500',
  },
  s: {
    classNames: 'w-8 h-8 text-ds-caption-s font-ds-500',
  },
  m: {
    classNames: 'w-12 h-12 text-ds-subtitle font-ds-400',
  },
  l: {
    classNames: 'w-20 h-20 text-ds-title font-normal',
  },
  xl: {
    classNames: 'w-[120px] h-[120px] text-[28px] font-light',
  },
};

export const Avatar: React.FC<AvatarProps> = ({ size = 's', text, image, className }) => {
  const [imgError, setImgError] = useState(false);

  const containerClasses = classNames(
    'flex items-center justify-center rounded-full bg-ds-bg-surface-soft-1',
    className,
    sizes[size].classNames,
  );

  if (image && !imgError) {
    return (
      <div className={containerClasses}>
        <img
          src={image}
          alt={text || 'avatar'}
          className="h-full w-full object-cover rounded-full"
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  if (text) {
    const initials =
      text?.length <= 2
        ? text
        : text
            .split(' ')
            .slice(0, 2)
            .map((word) => word[0])
            .join('')
            .toUpperCase();

    return (
      <div className={containerClasses}>
        <div className="uppercase text-ds-text-1">{initials}</div>
      </div>
    );
  }

  return <div className={containerClasses}></div>;
};
